const difference = require('@turf/difference');
const {polygonToLine} = require('@turf/polygon-to-line');

export const donut = featureCollection => ({
  ...featureCollection,
  features: featureCollection.features
    .sort((a, b) => a.properties.value - b.properties.value)
    .map((feature, i) => i > 0 ? difference(feature, featureCollection.features[i - 1]) : feature)
});

export const outerline = featureCollection => ({
  ...featureCollection,
  features: featureCollection.features
    .map(feature => polygonToLine(feature))
});